import './credits.css';

export enum Licenses {
    CC0 = 'Creative Commons 0',
    CC_BY_3 = 'Attribution 3.0',
    CC_BY_4 = 'Attribution 4.0',
    APACHE = 'Apache License 2.0',
    CC_BY_SA_3 = 'Attribution-Share Alike 3.0',
    GPL_2 = 'GNU General Public License 2.0',
    GPL_3 = 'GNU General Public License 3.0',
}

const LICENSE_LINKS: { [license in Licenses]: string } = {
    [Licenses.CC0]: 'https://creativecommons.org/publicdomain/zero/1.0/',
    [Licenses.CC_BY_3]: 'https://creativecommons.org/licenses/by/3.0/',
    [Licenses.CC_BY_4]: 'https://creativecommons.org/licenses/by/4.0/',
    [Licenses.APACHE]: 'https://www.apache.org/licenses/LICENSE-2.0.html',
    [Licenses.CC_BY_SA_3]: 'https://creativecommons.org/licenses/by-sa/3.0/',
    [Licenses.GPL_2]: 'https://www.gnu.org/licenses/old-licenses/gpl-2.0.html',
    [Licenses.GPL_3]: 'https://www.gnu.org/licenses/gpl-3.0.html',
};

interface AttributionProps {
    usage: string;
    name?: string;
    author?: string;
    link: string;
    licenses: Licenses[];
}

function Attribution(props: AttributionProps) {
    const { usage, name, author, link, licenses } = props;
    return (
        <>
            <li>{usage}:</li>
            <div className="attribution">
                {name && `${name} by `}
                {author && author} --{' '}
                <a href={link} target="_blank" rel="noopener noreferrer">
                    {link}
                </a>{' '}
                -- License:{' '}
                {licenses.map((license) => {
                    return (
                        <a
                            key={license}
                            href={LICENSE_LINKS[license]}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {license}
                        </a>
                    );
                })}
            </div>
        </>
    );
}

export default Attribution;
